import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { withLoading } from '@ps/core-loading';
import { SelectableQualificationDatum } from '@ps/survey-utils';

import { LocationConditionDto } from './dtos/location-condition.dto';
import { LocationConditionMapper } from './mappers/location-condition.mapper';

@Injectable({ providedIn: 'root' })
export class LocationConditionsApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _baseUrl = this._env.pureSpectrum.url;
  private readonly _mapper = new LocationConditionMapper();

  // searchText is always empty — the lookup endpoint returns every option for the qualification
  // when it's blank, which is what lets the full list be cached once and filtered client-side
  // (see SearchLocationQualificationContentComponent) instead of re-fetched per keystroke.
  public getAll(
    dbQualificationCode: number,
    locale: string,
  ): Observable<SelectableQualificationDatum[]> {
    return this._http
      .get<
        LocationConditionDto[]
      >(`${this._baseUrl}/buyers/v2/qualifications/${dbQualificationCode}/lookup`, { params: { locale, searchText: '' }, context: withLoading('page') })
      .pipe(map((response) => this._mapper.fromDtoList(response)));
  }
}
